import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";

import { CircularProgress } from "../AttachmentPreviews/CircularProgress";

export interface CancelButtonWithProgressProps {
  isUploading: boolean;
  progress: number;
  queuedForCancellation: any;
  removeCurrentAttachment: () => void;
}

export const CancelButtonWithProgress = ({
  queuedForCancellation,
  removeCurrentAttachment,
  progress,
  isUploading,
}: CancelButtonWithProgressProps) => (
  <button
    type="button"
    aria-label={t("tiptap.remove_attachment")}
    onClick={e => {
      queuedForCancellation.current = true;
      removeCurrentAttachment();
      e.preventDefault();
    }}
    className={classNames(
      "group absolute -right-3 -top-3 z-[1] hidden cursor-pointer items-center justify-center rounded-full border-2 border-tertiary bg-inverse group-hover:flex",
      {
        "hidden group-hover:block": !isUploading,
      },
    )}
  >
    {isUploading && (
      <div className="m-1 flex !h-4 !w-4 items-center justify-center group-hover/close-button:hidden">
        <CircularProgress percentage={progress} size={14} strokeWidth={2} />
      </div>
    )}
    <div
      className={classNames({
        "hidden group-hover/close-button:block": isUploading,
      })}
    >
      <Icon
        name="cross"
        aria-hidden
        size="sm"
        className="m-1"
        color="inverse"
      />
    </div>
  </button>
);
